import { useAudio } from "./useAudio";

export default function AudioManager(): null {
  useAudio();
  return null;
}
